namespace RioERP.Users {
    export interface CustomerWhatsAppRequest extends Serenity.ServiceRequest {
        Status?: string;
        ids?: string;
    }
}
